import React, { useEffect, useRef } from 'react';
import { Star, User } from 'lucide-react';

const MapAndReviews = () => {
  const sectionRef = useRef(null);
  const mapRef = useRef(null);
  const reviewsRef = useRef(null);

  const reviews = [
    {
      name: "Charoshi Borucawa",
      reviewCount: 8,
      rating: 5,
      timeAgo: "6 miesięcy temu",
      review: "Sytuacaja awaryjna, kryzysowa - pęknięta półoś 250km od domu. Ale udało się wymienić jeszcze w tym samym dniu! Szacun, ogromna wdzięczność za życzliwość, poświęcenie, (bo do 22 się zeszło) i w ogóle gorąco polecam:)",
      ownerResponse: "Dziękujemy za pozytywną opinię 🙏😊. Życzę jak najmniej takich sytuacji 😳 ale w razie co polecam się na przyszłość 😁…",
      responseTime: "4 miesiące temu"
    },
    {
      name: "truskawxka",
      reviewCount: 10,
      rating: 5,
      timeAgo: "7 miesięcy temu",
      review: "Pan Michał to najlepszy mechanik, u jakiego byłam. Zawsze pomoże, doradzi i zrobi tak, żeby było dobrze, a nie drogo. Miły, uczciwy i zna się na swojej robocie – polecam każdemu!",
      ownerResponse: "Dziękujemy za pozytywną opinię🙏",
      responseTime: "7 miesięcy temu",
      badge: "Lokalny przewodnik"
    },
    {
      name: "Jakub Felbur",
      reviewCount: 17,
      rating: 5,
      timeAgo: "4 miesiące temu",
      review: "Super mechanik . Bardzo dobry kontakt , tanio (w porównaniu do okolocznych warsztatow), świetnie wykonana robota . POLECAM",
      ownerResponse: "Dziękujemy za pozytywną opinię 🙏😊…",
      responseTime: "4 miesiące temu",
      badge: "Lokalny przewodnik"
    },
    {
      name: "Józef Recki",
      reviewCount: 1,
      rating: 5,
      timeAgo: "9 miesięcy temu",
      review: "Ja mówię na co zachorowalo moje auto a p. Michał wleczył je w czasie na dwa papierosy. Pełen profesjonalizm",
      ownerResponse: "Miło słyszeć że klient jest zadowolony 😁. Polecam się na przyszłość. I oby wszyscy klienci byli tak mili jak Pan. …",
      responseTime: "9 miesięcy temu"
    },
    {
      name: "Patrycja Kurdzielewicz",
      reviewCount: 1,
      rating: 5,
      timeAgo: "4 miesiące temu",
      review: "Szybka i profesjonalna obsługa. Polecam",
      ownerResponse: "Dziękujemy 🙏",
      responseTime: "4 miesiące temu"
    },
    {
      name: "Maciej Rosiński",
      reviewCount: 1,
      rating: 5,
      timeAgo: "2 lata temu",
      review: "Polecam współpracę z tym warsztatem, szybka diagnoza i wycena usługi, plus profesjonalne jej usunięcie uterki"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === mapRef.current) {
              entry.target.classList.add('slide-in-left');
            } else if (entry.target === reviewsRef.current) {
              entry.target.classList.add('slide-in-right');
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    [mapRef, reviewsRef].forEach(ref => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  const StarRating = ({ rating }) => {
    return (
      <div className="flex space-x-1">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-4 h-4 ${i < rating ? 'text-pink-500 star-rating' : 'text-gray-600'}`}
            style={i < rating ? { fill: '#f215e0', color: '#f215e0' } : {}}
          />
        ))}
      </div>
    );
  };

  return (
    <section ref={sectionRef} className="py-12 md:py-20 px-4 bg-gradient-to-b from-transparent to-black/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {/* Map Section */}
          <div ref={mapRef} className="opacity-0 w-full">
            <h2 className="font-passion text-3xl md:text-4xl lg:text-5xl font-bold text-cyan-400 text-center mb-6 md:mb-8">
              LOKALIZACJA
            </h2>
            <h3 className="font-rajdhani text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center" style={{ color: '#f215e0' }}>
              Znajdź nas
            </h3>
            <div className="relative w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19117.4931533963!2d18.3884696!3d53.20553580000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4703252ce23f737d%3A0xd9130b195500fa95!2sMial%20Car%20Service!5e0!3m2!1spl!2spl!4v1775661307879!5m2!1spl!2spl"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-xl w-full"
                title="Mapa lokalizacji Mial Car Service"
              />
            </div>
          </div>

          {/* Reviews Section */}
          <div ref={reviewsRef} className="opacity-0 w-full">
            <h2 className="font-passion text-3xl md:text-4xl lg:text-5xl font-bold text-cyan-400 text-center mb-6 md:mb-8">
              OPINIE
            </h2>
            <h3 className="font-rajdhani text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center" style={{ color: '#f215e0' }}>
              Opinie Klientów
            </h3>
            <div className="space-y-4 md:space-y-6 max-h-[450px] overflow-y-auto pr-2 md:pr-4 custom-scrollbar">
              {reviews.map((review, index) => (
                <div key={index} className="glass-morphism rounded-xl p-4 md:p-6 hover:scale-105 transform transition-all duration-300 w-full">
                  {/* User Info */}
                  <div className="flex items-start space-x-3 md:space-x-4 mb-3 md:mb-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-pink-500 to-cyan-400 flex items-center justify-center flex-shrink-0">
                      <User className="w-5 h-5 md:w-6 md:h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-1 md:gap-2 mb-2">
                        <h4 className="font-rajdhani font-bold text-white text-base md:text-lg break-words">
                          {review.name}
                        </h4>
                        {review.badge && (
                          <span className="text-xs px-2 py-1 rounded-full bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 whitespace-nowrap">
                            {review.badge}
                          </span>
                        )}
                      </div>
                      <div className="flex flex-wrap items-center gap-2 mb-1">
                        <StarRating rating={review.rating} />
                        <span className="text-gray-400 text-xs md:text-sm whitespace-nowrap">{review.timeAgo}</span>
                      </div>
                      <span className="text-gray-400 text-xs md:text-sm">
                        ({review.reviewCount} {review.reviewCount === 1 ? 'opinia' : 'opinii'})
                      </span>
                    </div>
                  </div>
                  
                  {/* Review Text */}
                  <p className="text-gray-200 font-rajdhani text-sm md:text-base leading-relaxed mb-3 md:mb-4 break-words">
                    "{review.review}"
                  </p>
                  
                  {/* Owner Response */}
                  {review.ownerResponse && (
                    <div className="bg-black/30 rounded-lg p-3 md:p-4 border-l-4" style={{ borderLeftColor: '#f215e0' }}>
                      <div className="flex flex-wrap items-center gap-2 mb-2">
                        <span className="font-bold text-xs md:text-sm" style={{ color: '#f215e0' }}>Odpowiedź właściciela</span>
                        <span className="text-gray-500 text-xs">({review.responseTime})</span>
                      </div>
                      <p className="text-gray-300 text-xs md:text-sm font-rajdhani break-words">
                        {review.ownerResponse}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapAndReviews;
